import { combineReducers } from 'redux';
import commonState from './commonState';
import ptzState from './ptzState';

export default combineReducers({
  commonState,
  ptzState,
});
